import { useIsBelowTablet } from 'hooks/use-is-below-tablet/use-is-below-tablet.hooks';

export const usePageHeaderHeight = () => {
  const isBelowTablet = useIsBelowTablet();
  return isBelowTablet ? 96 : 140;
};
